// extracted by mini-css-extract-plugin
export default {"tableLoadingOverlay":"_1TPhiYMkrgqxLw-moIWex1","loadingBox":"_3dOyR7fwliPZsR_qNqyyzj"};